jQuery(document).ready(function($){
	var settingsDiv = 'choralorg-options';
	var postAction = 'choralorg_options_add_table_row';

	$('#' + settingsDiv + ' .add-row').on('click', function(e){
		e.preventDefault();
		console.log('clicked');
		var parentDiv = $(this).closest('.options-field');
		var dataTable = parentDiv.find('table');

		var row = dataTable.find('tr').length - 1; //Subtract 1 because of header row

		var data = {
			action: postAction,
			field_prefix: $(this).attr('field-prefix'),
			row: row
		};
		$.post('/wp-admin/admin-ajax.php', data, function(response){
			dataTable.append(response);
			writeMoreInfoObject(parentDiv);
		});
	});

	$('#' + settingsDiv + ' .options-field').on('click', '.remove-row', function(e){
		e.preventDefault();

		var parentRow = $(this).closest('tr');
		var parentDiv = $(this).closest('.options-field');

		parentRow.remove();
		writeMoreInfoObject(parentDiv);
	});

	$('#' + settingsDiv + ' .options-field').on('change', 'table input', function(e){
		var parentDiv = $(this).closest('.options-field');
		writeMoreInfoObject(parentDiv);
	}); 

	function writeMoreInfoObject(el) {
		var resultObj = {};
		el.find('table input').each(function(){
			var name = $(this).attr('name');
			var value = $(this).val();

			if(!name.includes('-duplicate')) {
				resultObj[name] = value;
			}
		});

		var hiddenValueField = el.find('.hidden-value-field');

		hiddenValueField.val(JSON.stringify(resultObj));
	}
});